import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IRegisterPushTokenBody } from './register-push-token-request';
import type { IRegisterPushTokenResponse } from './register-push-token-response';
import { registerPushTokenResponseSchema } from './register-push-token-response';

export async function registerPushTokenApi(
  body: IRegisterPushTokenBody,
): Promise<IValidatedResponse<IRegisterPushTokenResponse>> {
  return postRequest<IRegisterPushTokenResponse>({
    path: '/account/push-token',
    body,
    schema: registerPushTokenResponseSchema,
  });
}
